<div class="mobile-tooltip-container">
    <p class="content">{{ data.text }}</p>
</div>
